module.exports = __webpack_public_path__ + "img/9df4d1b.jpg";